import { enCommon } from "./en/common";
import { enNavbar } from "./en/navbar";
import { enOpbouw } from "./en/opbouw";
import { frCommon } from "./fr/common";
import { frNavbar } from "./fr/navbar";
import { frOpbouw } from "./fr/opbouw";
import { nlCommon } from "./nl/common";
import { nlNavbar } from "./nl/navbar";
import { nlOpbouw } from "./nl/opbouw";
import { nlSettings } from "./nl/settings";
import { frSettings } from "./fr/settings";
import { enSettings } from "./en/settings";

export const ui = {
  NL: {
    ...nlCommon,
    ...nlNavbar,
    ...nlOpbouw,
    ...nlSettings
  },
  FR: {
    ...frCommon,
    ...frNavbar,
    ...frOpbouw,
    ...frSettings,
  },
  EN: {
    ...enCommon,
    ...enNavbar,
    ...enOpbouw,
    ...enSettings,
  },
} as const;

export type Language = keyof typeof ui;

export function resolveLanguage(language?: string): Language {
  const value = (language || sessionStorage.getItem("language") || "NL")
    .replace(/"/g, "")
    .toUpperCase();

  if (value === "FR" || value === "EN" || value === "NL") {
    return value;
  }

  return "NL";
}

export function getDictionary(language?: string) {
  const lang = resolveLanguage(language);

  // Merge with Dutch so missing keys in FR/EN do not break the UI.
  return {
    ...ui.NL,
    ...(ui[lang] ?? {}),
  };
}
